export default "__VITE_ASSET__ltJcbwtR__"